define ['./password_reset_done.scss'], () ->
  ($scope, $state, RentappService, $rootScope) ->
    $scope.go_to_login = () -> 
      if $rootScope.WHITE_LABEL
        $state.go "root.home.landing"
      else 
        $state.go "root.home.login"
        


// WEBPACK FOOTER //
// ./components/home/password_reset_done/password_reset_done.coffee